export const prefabNames: string[] = [
  '_TerrainCompiler', '_ZoneCtrl',
  'Skeleton_NoArcher', 'Draugr_Ranged', 'woodwall',

  'acacitree', 'ancientbarkspear_projectile', 'aoe_nova',
  
  'BarleyWineBase', 'MeadBaseBarleyWine', 'barrell',
  // 'Beard1', 'Beard2', 'Beard3', 'Beard4', 'Beard5', 'Beard6', 'Beard7', 'Beard8', 'Beard9', 'Beard10', 'BeardNone',
  'bee_aoe',
  'Birch1_aut', 'Birch2_aut', 'Birch2',
  'BlackForestLocationMusic', 'FrostCavesShrineReveal', 'FrostCavesSanctumMusic', 'Music_GreydwarfCamp', 'Music_Haldor2', 'Music_StoneHenge', 'Music_FulingCamp',
  'blob_aoe', 'blob_attack_aoe', 'blobelite_attack_aoe', 'blobtar_attack', 'blobtar_projectile_tarball',
  'boar_base_attack', 'Boar_piggy', 'boar_ragdoll',
  'bonemass_aoe', 'bonemass_attack_aoe', 'bonemass_attack_punch', 'bonemass_attack_spawn', 'bonemass_attack_throw', 'bonemass_spawn', 'bonemass_throw_projectile',
  'BossStone_Bonemass', 'BossStone_DragonQueen', 'BossStone_Eikthyr', 'BossStone_TheElder', 'BossStone_Yagluth', 'BossStone_TheQueen', 'BossStone_Fader',
  'bow_projectile', 'bow_projectile_fire', 'bow_projectile_frost', 'bow_projectile_needle', 'bow_projectile_poison',
  'bronzespear_projectile',
  'bucket',

  'CargoCrate',
  'CastleKit_braided_box01', 'CastleKit_brazier', 'CastleKit_groundtorch', 'CastleKit_groundtorch_green', 'CastleKit_groundtorch_unlit', 'CastleKit_metal_groundtorch_unlit', 'CastleKit_pot03',
  'caverock_ice_stalagmite_broken', 'caverock_ice_stalagmite_destruction', 'caverock_ice_stalagtite_destruction', 'caverock_ice_stalagtite_falling', 'caverock_ice_wall_destruction',
  'cloth_hanging_door_double', 'cloth_hanging_door', 'cloth_hanging_long', 'piece_cloth_hanging_door',
  'clutter_shrub_large',
  'cultivate', 'cultivate_v2',

  'dead_deer',
  'Deathsquito_sting', 'DeerGodExplosion',
  'DevHouse1', 'DevSoundTest',
  'DG_AshlandRuins', 'DG_Cave', 'DG_DvergrBoss', 'DG_DvergrTown', 'DG_ForestCrypt', 'DG_FortressRuins', 'DG_GoblinCamp', 'DG_MeadowsFarm', 'DG_MeadowsVillage', 'DG_SunkenCrypt',
  'DG_Hildir_Cave', 'DG_Hildir_ForestCrypt', 'DG_Hildir_PlainsFortress',
  'DG_MeadowsFarm', 'DG_MeadowsVillage', 'DG_SunkenCrypt',
  'digg', 'digg_v2', 'digg_v3',
  'drag_item',
  'dragon_bite', 'dragon_claw_left', 'dragon_claw_right', 'dragon_coldbreath', 'dragon_coldbreath_OLD', 'dragon_ice_projectile', 'dragon_split_shotgun', 'dragon_taunt',
  'dragoneggcup',
  'Draugr_Ranged', 'draugr_arrow', 'draugr_axe', 'draugr_bow', 'draugr_bow_projectile', 'draugr_sword',
  'dungeon_forestcrypt_door', 'dungeon_sunkencrypt_irongate',
  'dvergrrock_curvedrock', 'dvergrrock_rockburn',
    
  'Eikthyr_antler', 'Eikthyr_charge', 'Eikthyr_flegs_OLD', 'Eikthyr_stomp',
  'eventzone_bonemass', 'eventzone_eikthyr', 'eventzone_gdking', 'eventzone_goblinking', 'eventzone_moder',
  'EvilHeart_Forest', 'EvilHeart_Swamp',
    
  'Fenring_attack_claw', 'Fenring_attack_jump', 'Fenring_taunt',
  'fenrirhide_hanging_door', 'fenrirhide_hanging',
  'FireFlies', 'Flies',
  'Fish1', 'Fish2', 'Fish3', 'Fish4_cave', 'FishingRodFloat', 'FishingRodFloatProjectile',
  'Flash', 'flintspear_projectile',

  'gd_king_punch', 'gd_king_rootspawn', 'gd_king_scream', 'gd_king_shoot', 'gd_king_stomp', 'gdking_root_projectile',
  'Ghost_attack',
  'goblin_banner', 'goblin_bed', 'goblin_fence', 'goblin_pole', 'goblin_pole_small', 'goblin_roof_45d', 'goblin_roof_45d_corner', 'goblin_roof_cap', 'goblin_stairs', 'goblin_stepladder', 'goblin_totempole', 'goblin_woodwall_1m', 'goblin_woodwall_2m', 'goblin_woodwall_2m_ribs',
  'GoblinArmband', 'GoblinArcher',
  'GoblinBrute_ArmGuard', 'GoblinBrute_Attack', 'GoblinBrute_Backbones', 'GoblinBrute_ExecutionerCap', 'GoblinBrute_HipCloth', 'GoblinBrute_LegBones', 'GoblinBrute_ragdoll', 'GoblinBrute_RageAttack', 'GoblinBrute_ShoulderGuard', 'GoblinBrute_Taunt', 
  'GoblinClub', 'GoblinHelmet', 'GoblinKing_Beam', 'GoblinKing_Meteors', 'GoblinKing_Nova', 'GoblinKing_ragdoll', 'GoblinKing_Taunt', 'goblinking_totemholder',
  'GoblinLegband', 'GoblinLoin',
  'GoblinShaman_attack_fireball', 'GoblinShaman_attack_poke', 'GoblinShaman_attack_protect',
  'GoblinShaman_Headdress_antlers', 'GoblinShaman_Headdress_feathers',
  'GoblinShaman_projectile_fireball', 'GoblinShaman_protect_aoe',
  'GoblinShaman_Staff_Bones', 'GoblinShaman_Staff_Feathers',
  'GoblinShoulders', 'GoblinSpear', 'GoblinSpear_projectile', 'GoblinSword',
  'GoblinTorch',
  'grassross_heath_green',
  'Greydwarf_attack',
  'Greydwarf_elite_attack',
  'Greydwarf_Root',
  'Greydwarf_Shaman_attack', 'Greydwarf_Shaman_heal', 'Greydwarf_Shaman_ragdoll',
  'Greydwarf_throw',
  'Greydwarf_throw_projectile',
  'Greyling_attack',
  'guard_stone', 'guard_stone_test',
    
  'Hair1', 'Hair2', 'Hair3', 'Hair4', 'Hair5', 'Hair6', 'Hair7', 'Hair8', 'Hair9', 'Hair10', 'Hair11', 'Hair12', 'Hair13', 'Hair14', 'HairNone',
  'Haldor', 'Hildir',
  'hatchling_cold_projectile', 'hatchling_spit_cold', 'HealthUpgrade_Bonemass', 'HealthUpgrade_GDKing',
  'highstone', 'highstone_frac', 'horizontal_web', 'HugeRoot1', 'HugeStone1',

  'Ice_floor', 'Ice_floor_fractured',
  'ice_rock1', 'ice_rock1_frac', 'ice1', 'IceBlocker',
  'imp_fireball_attack', 'Imp_fireball_projectile', 'instanced_forest_groundcover', 'instanced_forest_groundcover_brown', 'instanced_heathflower', 'instanced_heathgrass', 'instanced_meadowsgrass', 'instanced_meadowsgrass_short', 'instanced_ormbunke', 'instanced_shrub', 'instanced_small_rock1', 'instanced_swamp_grass', 'instanced_swamp_ormbunke', 'instanced_vass', 'instanced_waterlilies',

  'jute_carpet', 'JuteRed',

  'Leech_BiteAttack', 'Leech_cave',
  'lightningAOE',
  'LocationProxy', 'loot_chest_stone', 'loot_chest_wood', 'LootSpawner_pineforest',
  'lox_bite', 'Lox_Calf', 'lox_ribs', 'lox_stomp', 'lox_stomp_aoe_OLD', 'loxcalf_ragdoll',

  'MapPin',
  'marker01', 'marker02',
  'MineRock_Copper', 'MineRock_Iron', 'MineRock_Meteorite', 'MineRock_Stone',
  'MountainKit_brazier', 'mountainkit_chair', 'mountainkit_table', 'MountainKit_wood_gate',
  'mud_road', 'mud_road_v2', 'mudpile_old',
  'MusicVolume', 'MusicLocation',
    
  'Neck_BiteAttack',
    
  'odin',
  'OLD_wood_roof', 'OLD_wood_roof_icorner', 'OLD_wood_roof_ocorner', 'OLD_wood_roof_top', 'OLD_wood_wall_roof',
  'oozebomb_explosion', 'oozebomb_projectile', 'ormbunke_green_medium',

  'path', 'path_v2', 'paved_road', 'paved_road_v2',
  'Pickable_Barley_Wild', 'Pickable_BogIronOre', 'Pickable_Branch', 'Pickable_Flax_Wild', 'Pickable_Item', 'Pickable_Meteorite', 'Pickable_MountainRemains01_buried', 'Pickable_Mushroom_blue',  'Pickable_Obsidian', 'Pickable_RandomFood', 'Pickable_Tin',
  'PlaceMarker', 'Player', 'Player_ragdoll', 'Player_ragdoll_old', 'Player_tombstone', 'PlayerUnarmed',
  'portal',
  'projectile_beam', 'projectile_chitinharpoon', 'projectile_meteor', 'projectile_wolffang',

  'raise', 'raise_v2', 'RandomAmbientBase', 'Ravens',
  'replant', 'replant_v2', 'Resin',
  'Rock_3', 'Rock_3_frac', 'Rock_4', 'Rock_4_plains', 'Rock_7', 'rock_a', 'Rock_destructible', 'Rock_destructible_test',
  'RockDolmen_1', 'RockDolmen_2', 'RockDolmen_3',
  'RockFinger', 'RockFinger_frac', 'RockFingerBroken', 'RockFingerBroken_frac', 'rockformation1',
  'RockThumb', 'RockThumb_frac',
  'Root', 'root07', 'root08', 'root11', 'root12',

  'sapling_barley', 'sapling_carrot', 'sapling_flax', 'sapling_onion', 'sapling_seedcarrot', 'sapling_seedonion', 'sapling_seedturnip', 'sapling_turnip', 'Sausages',
  'Beech_Sapling', 'FirTree_Sapling', 'PineTree_Sapling', 'Birch_Sapling', 'Oak_Sapling', 'sapling_seedturnip', 'sapling_seedcarrot', 'sapling_seedonion',
  'Serpent_attack', 'Serpent_taunt', 'SerpentMeat', 'SerpentMeatCooked', 'SerpentScale', 'SerpentStew',
  'shaman_attack_aoe', 'shaman_heal_aoe', 
  'ship_construction',
  'sign', 'sign_notext',
  'skeleton_bow', 'skeleton_mace', 'skeleton_sword', 'Skeleton_NoArcher',
  'Skull1', 'Skull2',
  'sledge_aoe',
  'small_rock1', 'small_rock2',
  'smelter', 'SmokeBall',
  'spawn_meteors', 'spawn_roots',
  'Spawner_Bat', 'Spawner_Blob', 'Spawner_BlobElite', 'Spawner_BlobTar', 'Spawner_BlobTar_respawn_30', 'Spawner_Boar', 'Spawner_Cultist', 'Spawner_Draugr', 'Spawner_Draugr_Elite', 'Spawner_Draugr_Noise', 'Spawner_Draugr_Ranged', 'Spawner_Draugr_Ranged_Noise', 'Spawner_Draugr_respawn_30', 'Spawner_DraugrPile', 'Spawner_Fenring', 'Spawner_Fish4', 'Spawner_Ghost', 'Spawner_Goblin', 'Spawner_GoblinArcher', 'Spawner_GoblinBrute', 'Spawner_GoblinShaman', 'Spawner_Greydwarf', 'Spawner_Greydwarf_Elite', 'Spawner_Greydwarf_Shaman', 'Spawner_GreydwarfNest', 'Spawner_Hatchling', 'Spawner_imp', 'Spawner_imp_respawn', 'Spawner_Leech_cave', 'Spawner_Location_Elite', 'Spawner_Location_Greydwarf', 'Spawner_Location_Shaman', 'Spawner_Skeleton', 'Spawner_Skeleton_night_noarcher', 'Spawner_Skeleton_poison', 'Spawner_Skeleton_respawn_30', 'Spawner_StoneGolem', 'Spawner_Troll', 'Spawner_Ulv', 'Spawner_Wraith',

  'StaminaUpgrade_Greydwarf', 'StaminaUpgrade_Troll', 'StaminaUpgrade_Wraith',
  'stoneblock_fracture', 'stonechest',
  'stonegolem_attack_doublesmash', 'stonegolem_attack_sonicboom', 'stonegolem_attack1_spike', 'stonegolem_attack2_left_groundslam', 'stonegolem_attack3_spikesweep', 'StoneGolem_clubs', 'StoneGolem_hat', 'StoneGolem_spikes', 'stubbe_spawner', 
  'sunken_crypt_gate',

  'TarLiquid', 'tarlump1', 'tarlump1_frac',
  'tentaroot_attack',
  'Thor',
  'tolroko_flyer',
  'Trailership', 'TrainingDummy',
  'troll_groundslam', 'troll_groundslam_aoe', 'troll_log_swing_h', 'troll_log_swing_v', 'troll_punch', 'troll_throw', 'troll_throw_projectile',
  'turf_roof', 'turf_roof_top', 'turf_roof_wall',
  
  'Valkyrie', 'VegvisirShard_Bonemass', 'vfx_edge_clouds', 'vfx_swamp_mist', 'vines',

  'Waystone',
  'Wolf_Attack1', 'Wolf_Attack2', 'Wolf_Attack3', 'Wolf_cub', 'Wolf_Ragdoll',
  'woodwall',
  'wraith_melee',

  'YagluthDrop',
];

export const modPrefabNames: Record<string, string[]> = {
  ChickenBoo: [
    'ChickenBoo', 'chicklet', 'cooked_chicken', 'fried_egg', 'boiled_egg', 'raw_egg', 'raw_chicken', 'chickensombrero', 'helmet'
  ],
  RRRCore: [
    'RRR_GDThornweaver', 'RRR_GhostVengeful', 'RRR_TrollTosser', 'RRR_Grig', 'RRR_GrigHorn',
  ],
  Hugos_Armory: [
    'DeerFistsHTD', 'BronzeFistsHTD', 'IronFistsHTD', 'SilverFistsHTD',
    'BronzeGreatSwordHTD', 'BronzeBattleaxeHTD', 'BronzeHammerHTD', 'BronzeCrowbillHTD',
    'IronGreatSwordHTD', 'IronHeavyGreatSwordHTD', 'DragonSlayerSwordHTD',
    'CoreGreatMaceHTD', 'CoreGreatMaceGreenHTD', 'CoreGreatMaceBlueHTD',
    'SilverGreatSwordHTD', 'SilverGreatMaceHTD', 'SilverBattleaxeHTD',
    'BlackMetalGreatSwordHTD', 'BlackMetalGreatSwordAltHTD', 'BlackMetalBattleaxeHTD',
    'BoneGreatMaceHTD', 'BoneGreatSwordHTD',
    'ObsidianGreatSwordHTD', 'ObsidianGreatSwordRedHTD', 'FlametalGreatSwordHTD',
  ],
  BuildIt: [
    'piece_buildtower',
    'rk_1mbeam', 'rk_1mbeam2',
    'rk_26beam', 'rk_26beam2',
    'rk_26inner', 'rk_26inner2',
    'rk_26ridge', 'rk_26ridge2',
    'rk_26roof_x',
    'rk_26to45wall', 'rk_26to45wall2', 'rk_26to45wall3', 'rk_26to45wall4', 'rk_26to45wall5', 'rk_26to45wall6',
    'rk_26wall', 'rk_26wall2', 'rk_26wall3', 'rk_26wall4', 'rk_26wall5',
    'rk_2mbeam', 'rk_2mhorzbeam', 'rk_2mvertbeam',
    'rk_45beam', 'rk_45beam2',
    'rk_45corner_roof', 'rk_45corner_roof2', 'rk_45corner_roof3',
    'rk_45inner', 'rk_45inner2',
    'rk_45ridge', 'rk_45ridge2',
    'rk_45roof', 'rk_45roof2', 'rk_45roof3',
    'rk_45roof_x',
    'rk_45wall', 'rk_45wall2', 'rk_45wall3', 'rk_45wall4', 'rk_45wall5',
    'rk_barrel', 'rk_barrel2',
    'rk_bed',
    'rk_blackpine',
    'rk_bonzai',
    'rk_brazier2',
    'rk_bucket',
    'rk_cabinet', 'rk_cabinet2',
    'rk_candle',
    'rk_chair',
    'rk_cherryblossom', 'rk_cherryblossom2', 'rk_cherryblossom3', 'rk_cherryblossom4',
    'rk_crate', 'rk_crate2',
    'rk_curvecorner', 'rk_curvecorner2',
    'rk_door', 'rk_door2', 'rk_door3', 'rk_door4', 'rk_door5', 'rk_door6', 'rk_door7', 'rk_door8', 'rk_door9',
    'rk_drawbridge',
    'rk_fence', 'rk_fence2', 'rk_fence3', 'rk_fence4', 'rk_fence5', 'rk_fence6', 'rk_fence7', 'rk_fence8', 'rk_fence9',
    'rk_fencehalf', 'rk_fenceheavy', 'rk_fenceheavy_corner',
    'rk_floor', 'rk_floor2', 'rk_floor3', 'rk_floor4', 'rk_floor5',
    'rk_floorquarter', 'rk_floorquarter4',
    'rk_fountain',
    'rk_gate', 'rk_gate2', 'rk_gate3', 'rk_gate4',
    'rk_glassdoor', 'rk_glassdoor2',
    'rk_groundbrazier',
    'rk_hammer',
    'rk_hearthdim', 'rk_hearthsmall',
    'rk_lamp', 'rk_lamphanging', 'rk_lamppost',
    'rk_maple',
    'rk_outhouse',
    'rk_post', 'rk_post2',
    'rk_pot',
    'rk_roof', 'rk_roof2', 'rk_roof3',
    'rk_roof_corner', 'rk_roof_corner2', 'rk_roof_corner3',
    'rk_rug', 'rk_rug2', 'rk_rug2large', 'rk_rugsmall',
    'rk_screen', 'rk_screen2',
    'rk_shelflong', 'rk_shelfsmall', 'rk_shelftable', 'rk_shelftable2',
    'rk_sidetable',
    'rk_sink',
    'rk_stairscurved',
    'rk_stairstone', 'rk_stairstone2', 'rk_stairstone3',
    'rk_stonehearth',
    'rk_stoneslab',
    'rk_stool',
    'rk_table',
    'rk_wall', 'rk_wall2', 'rk_wall3', 'rk_wall4', 'rk_wall5', 'rk_wall6', 'rk_wall7', 'rk_wall8', 'rk_wall9',
    'rk_wall10', 'rk_wall11', 'rk_wall12', 'rk_wall13', 'rk_wall14',
    'rk_well',
    'rk_window', 'rk_windowplain', 'rk_windowshort', 'rk_windowshortest',
    'rk_windowstone', 'rk_windowstonesmall',
    'rk_woodrack',
    'rk_woodstairs',
  ],
  BuildPieces: [
    'stone_archgate', 'stone_beam', 'stone_beam2', 'stone_beam4', 'stone_beam_26', 'stone_beam_46', 'stone_decowall', 'stone_door', 'stone_floor_flat_1x1', 'stone_floor_flat_2x2', 'stone_ledge', 'stone_pole', 'stone_pole2', 'stone_pole4', 'stone_reverse_arch', 'stone_roof', 'stone_roof_45', 'stone_roof_top', 'stone_stepladder', 'stone_wall_flat', 'stone_wall_flat_1x1', 'stone_wall_roof', 'stone_wall_roof_45', 'stone_wall_roof_45_upsidedown', 'stone_wall_roof_top', 'stone_wall_roof_top_45', 'stone_wall_roof_upsidedown',
    'ice_archgate', 'ice_beam', 'ice_beam2', 'ice_beam4', 'ice_beam_26', 'ice_beam_46', 'ice_decowall', 'ice_door', 'ice_floor_flat_1x1', 'ice_floor_flat_2x2', 'ice_ledge', 'ice_pole', 'ice_pole2', 'ice_pole4', 'ice_reverse_arch', 'ice_roof', 'ice_roof_45', 'ice_roof_top', 'ice_stepladder', 'ice_wall_flat', 'ice_wall_flat_1x1', 'ice_wall_roof', 'ice_wall_roof_45', 'ice_wall_roof_45_upsidedown', 'ice_wall_roof_top', 'ice_wall_roof_top_45', 'ice_wall_roof_upsidedown',
    'moss_archgate', 'moss_beam', 'moss_beam2', 'moss_beam4', 'moss_beam_26', 'moss_beam_46', 'moss_decowall', 'moss_door', 'moss_floor_flat_1x1', 'moss_floor_flat_2x2', 'moss_ledge', 'moss_pole', 'moss_pole2', 'moss_pole4', 'moss_reverse_arch', 'moss_roof', 'moss_roof_45', 'moss_roof_top', 'moss_stepladder', 'moss_wall_flat', 'moss_wall_flat_1x1', 'moss_wall_roof', 'moss_wall_roof_45', 'moss_wall_roof_45_upsidedown', 'moss_wall_roof_top', 'moss_wall_roof_top_45', 'moss_wall_roof_upsidedown',
    'clay_archgate', 'clay_beam', 'clay_beam2', 'clay_beam4', 'clay_beam_26', 'clay_beam_46', 'clay_decowall', 'clay_door', 'clay_floor_flat_1x1', 'clay_floor_flat_2x2', 'clay_ledge', 'clay_pole', 'clay_pole2', 'clay_pole4', 'clay_reverse_arch', 'clay_roof', 'clay_roof_45', 'clay_roof_top', 'clay_stepladder', 'clay_wall_flat', 'clay_wall_flat_1x1', 'clay_wall_roof', 'clay_wall_roof_45', 'clay_wall_roof_45_upsidedown', 'clay_wall_roof_top', 'clay_wall_roof_top_45', 'clay_wall_roof_upsidedown',
    'lava_archgate', 'lava_beam', 'lava_beam2', 'lava_beam4', 'lava_beam_26', 'lava_beam_46', 'lava_decowall', 'lava_door', 'lava_floor_flat_1x1', 'lava_floor_flat_2x2', 'lava_ledge', 'lava_pole', 'lava_pole2', 'lava_pole4', 'lava_reverse_arch', 'lava_roof', 'lava_roof_45', 'lava_roof_top', 'lava_stepladder', 'lava_wall_flat', 'lava_wall_flat_1x1', 'lava_wall_roof', 'lava_wall_roof_45', 'lava_wall_roof_45_upsidedown', 'lava_wall_roof_top', 'lava_wall_roof_top_45', 'lava_wall_roof_upsidedown',
  ],
  SuspicousPieces: ['sp_portal'],
  ElementalWasps: ['ew_forest', 'ew_fire', 'ew_frost', 'ew_spirit', 'ew_poison', 'ew_lightning'],
  ElementalOrbs: [
    'eo_wisp_treat',
    'eo_fire_low', 'eo_water_low', 'eo_frost_low', 'eo_shock_low', 'eo_nature_low', 'eo_wind_low', 'eo_arcane_low', 'eo_fairy_low', 'eo_holy_low', 'eo_light_low', 'eo_universe_low', 'eo_mist_low', 'eo_dark_low', 'eo_crimson_low', 'eo_void_low',
    'eo_fire_high', 'eo_water_high', 'eo_frost_high', 'eo_shock_high', 'eo_nature_high', 'eo_wind_high', 'eo_arcane_high', 'eo_fairy_high', 'eo_holy_high', 'eo_light_high', 'eo_universe_high', 'eo_mist_high', 'eo_dark_high', 'eo_crimson_high', 'eo_void_high',
    'eo_fire_orb', 'eo_water_orb', 'eo_frost_orb', 'eo_shock_orb', 'eo_nature_orb', 'eo_wind_orb', 'eo_arcane_orb', 'eo_fairy_orb', 'eo_holy_orb', 'eo_light_orb', 'eo_universe_orb', 'eo_mist_orb', 'eo_dark_orb', 'eo_crimson_orb', 'eo_void_orb',
    'eo_fire_wisp', 'eo_water_wisp', 'eo_frost_wisp', 'eo_shock_wisp', 'eo_nature_wisp', 'eo_wind_wisp', 'eo_arcane_wisp', 'eo_fairy_wisp', 'eo_holy_wisp', 'eo_light_wisp', 'eo_universe_wisp', 'eo_mist_wisp', 'eo_dark_wisp', 'eo_crimson_wisp', 'eo_void_wisp',
  ],
  CookieGrenades: [
    'cg_explosive', 'cg_fire', 'cg_frost', 'cg_spirit', 'cg_poison', 'cg_lightning',
  ],
  BackPacks_Remake: [
    'CapeLeatherBackpack',
    'CapeIronBackpack',
    'CapeSilverBackpack',
  ],
  PotionsPlus: [
    'Flask_of_Elements',
    'Flask_of_Fortification',
    'Flask_of_the_Gods',
    'Flask_of_Magelight',
    'Flask_of_Second_Wind',
    'Grand_Healing_Tide_Potion',
    'Grand_Spiritual_Healing_Potion',
    'Grand_Stamina_Elixir',
    'Grand_Stealth_Elixir',
    'Medium_Healing_Tide_Flask',
    'Medium_Spiritual_Healing_Flask',
    'Medium_Stamina_Flask',
    'Lesser_Healing_Tide_Vial',
    'Lesser_Spiritual_Healing_Vial',
    'Lesser_Stamina_Vial',
    'Potion_Meadbase',
    'PhilosopherStoneBlue',
    'PhilosopherStoneGreen',
    'PhilosopherStoneRed',
    'PhilosopherStonePurple',
    'PhilosopherStoneBlack',
    'opalchemy',
    'opcauldron',
  ],
  JudesEquipment: [
    'ArmorBarbarianBronzeHelmetJD', 'ArmorBarbarianBronzeChestJD', 'ArmorBarbarianBronzeLegsJD', 'ArmorBarbarianCapeJD',
    'ArmorPlateIronHelmetJD', 'ArmorPlateIronChestJD', 'ArmorPlateIronLegsJD',
    'ArmorDragonslayerHelmet', 'ArmorDragonslayerChest', 'ArmorDragonslayerLegs',
    'ArmorBlackmetalgarbHelmet', 'ArmorBlackmetalgarbChest', 'ArmorBlackmetalgarbLegs',
    'ArmorWandererHelmet', 'ArmorWandererChest', 'ArmorWandererLegs', 'ArmorWandererCape',
    'ArmorMistlandsHelmet', 'ArmorMistlandsChest', 'ArmorMistlandsLegs',
    'BackpackSimple', 'BackpackHeavy',
  ],
  ChaosArmor: [
    'T0ChaosPlateArmor', 'T0ChaosPlateArmor', 'T0ChaosPlateLegs',
    'T1ChaosPlateArmor', 'T1ChaosPlateHelm', 'T1ChaosPlateLegs',
    'T2ChaosPlateArmor', 'T2ChaosPlateHelm', 'T2ChaosPlateLegs',
    'ChaosPlateArmorBody', 'ChaosPlateHelm', 'ChaosPlateLegs',
    'EliteChaosPlateArmor', 'EliteChaosPlateHelm', 'ChaosPlateHelmAlt', 'EliteChaosPlateLegs',
  ],
  DoOrDieMonsters: [
    // from monster mash
    'CrazyTroll', 'EarthTroll',
    'Yeti', 'CapeYeti', 'YetiPelt',
    'Wizard',
    'WereWolfBlackArmored', 'WereWolfDarkGrey', 'WereWolfBlack', 'WereWolfBrown', 'WereWolfWhite', 'WerewolfCape',
    'WereBearBlack', 'WereBearGray', 'WereBearRed',
    'WendigoForest', 'WendigoSwamp',
    'EvilReaper', 'Golem2', 'TheNasty', 'Nasty_Spawner',
    // bosses
    'SkirSandburst_DoD', 'ShamansVessel_DoD', 'AltarRambone_DoD',
    'Farkas_DoD', 'LargeFang_DoD', 'AltarBitterstump_DoD',
    'Bhygshan_DoD', 'SkeletonBones_DoD', 'AltarBhygshan_DoD',
    'Bitterstump_DoD', 'GreydwarfHeart_DoD', 'AltarFarkas_DoD, AltarFarkasAlt_DoD',
    'Rambore_DoD', 'BoarTusk_DoD', 'AltarSkirSandburst_DoD',
    // creatures
    'GreaterSurtling_DoD', 'CharredRemains_DoD', 'SkeletonG_DoD', 'SkeletonR_DoD', 'FrozenBones_DoD', 'BlackDeer_DoD', 'BlackStag_DoD', 'IceGolem_DoD', 'LavaGolem_DoD', 'ObsidianGolem_DoD', 'Ghost_White_DoD', 'Ghost_Ice_DoD', 'Frostling_DoD', 'Stormling_DoD', 'Voidling_DoD', 'ForestWolf_DoD', 'ForestWolf_Cub_DoD', 'DireWolf_DoD', 'DireWolf_Cub_DoD', 'Vilefang_DoD', 'Vilefang_Cub_DoD', 'LivingLava_DoD', 'LivingWater_DoD', 'IceDrake_DoD', 'FlameDrake_DoD', 'ArcaneDrake_DoD', 'GoldDrake_DoD', 'DarknessDrake_DoD', 'PoisonDrake_DoD', 'DarkDrake_DoD',
    // buildables
    'Rug_BlackDeer_DoD', 'Rug_ForestWolf_DoD', 'Rug_DireWolf_DoD',
    // trophies
    'TrophyIceDrake_DoD', 'TrophyFlameDrake_DoD', 'TrophyArcaneDrake_DoD', 'TrophyDarknessDrake_DoD', 'TrophyGoldDrake_DoD', 'TrophyPoisonDrake_DoD', 'TrophyFrostling_DoD', 'TrophyStormling_DoD', 'TrophyVoidling_DoD', 'TrophyOGolem_DoD', 'TrophyLGolem_DoD', 'TrophyIceGolem_DoD', 'TrophyVilefang_DoD', 'TrophyDireWolf_DoD', 'TrophyForestWolf_DoD', 'TrophyLivingLava_DoD', 'TrophyLivingWater_DoD', 'TrophyBlackDeer_DoD', 'TrophyFrozenBones_DoD',
    // materials
    'InfusedGemstone_DoD', 'DireWolfPelt_DoD', 'ForestWolfPelt_DoD', 'FrostlingCore_DoD', 'StormlingCore_DoD', 'VoidlingCore_DoD', 'WaterGlobe_DoD', 'SpiderChitin_DoD', 'BlackDeerHide_DoD',
  ],
  MonsterLabZ: [
    'BlackSpider', 'BrownSpider', 'ForestSpider', 'FrigidSpider', 'FrostSpider', 'GreenSpider', 'TanSpider', 'TreeSpider',
    'DeepSea_Serpent',
    'FireGolem',
    'ML_DraugrShip', 'ML_GoblinLox', 'ML_GoblinShip',
    'Greydwarf_Purple', 'Greydwarf_Purple_Shroom',
    'IceGolem',
    'Kraken', 'KrakenLD', 'Kraken_Blob',
    'Molluscan', 'MolluscanLand',
    'NightmareDragon',
    'ObsidianGolem',
    'Rainbow_Butterfly', 'Green_Butterfly', 'Silkworm_Butterfly',
    'Spider_Boss',
    'Surtling_Spawn',
    'DwarfGoblin', 'DwarfGoblinLoot', 'DwarfGoblinShaman',
    'NormalGhostWarrior',
    'ChaosSkeletonWarrior', 'ChaosSkeletonWarriorNoFX',
    'FireSkeletonWarrior', 'FireSkeletonWarriorNoFx',
    'IceSkeletonWarrior', 'IceSkeletonWarriorNoFx',
    'NormalSkeletonWarrior',
    'PoisonSkeletonWarrior', 'PoisonSkeletonWarriorNoFx',
    'Succubus', 'Succubus_Queen1',
    'Surtr',
    'WraithWarrior',
    'MLNPC_Female0', 'MLNPC_Male0', 'MLNPC_Male1', 'MLNPC_Male2', 'MLNPC_Male3',
    'MLNPC_Svartalfar0',
  ],

  Terraheim: [
    'ArrowGreatFireTH',
    'AtgeirSilver',
    'AtgeirFireTH',
    'AxeForstasca',
    'AxeSerpentTH',
    'AxeFireTH',
    'GreataxeFlintTH',
    'BattleaxeBronzeTerraheim',
    'BattleaxeSilver',
    'GreataxeBlackmetal',
    'BattleaxeFireTH',
    'BombFire',
    'BombLightning',
    'BombFrost',
    'BowBlackmetalTH',
    'BowFireTH',
    'JavelinBronze',
    'JavelinFlint',
    'KnifeIron',
    'KnifeSilverTH',
    'KnifeFireTH',
    'GreatswordIron',
    'GreatswordChitinTH',
    'SwordFolcbrand',
    'GreatswordBlackmetal',
    'GreatswordFireTH',
    'MaceFireTH',
    'ShieldSilverDagger',
    'ShieldFireTH',
    'ShieldFireTowerTH',
    'BattleaxeBlackmetal',
    'SledgeFireTH',
    'SpearBlackmetal',
    'SpearFireTH',
    'ThrowingAxeFlint',
    'ThrowingAxeBronze',
    'ThrowingAxeIron',
    'ThrowingAxeSilver',
    'ThrowingAxeBlackmetal',
    'ThrowingAxeFire',
    'SalamanderFurTH',
    'PickaxeBlackMetal',

    'HelmetWoodsman_Terraheim_AddCirculets_AddWoodsmanCirculet',
    'BeltMiner_Terraheim_AddCirculets_AddMinersCirculet',
    'BeltFarmer_Terraheim_AddCirculets_AddFarmerBelt',
    'BeltThief_Terraheim_AddCirculets_AddThiefBelt',
    'BeltWaterproof_Terraheim_AddCirculets_AddWaterproofBelt',
    'CapeDeerHideT0TH',
    'CapeDeerHideT1TH',
    'CapeTrollHideT0TH',
    'CapeTrollHideT1TH',
    'CapeWolfT1TH',
    'CapeLoxT1TH',
    'CapeLinenT0TH',
    'CapeLinenT1TH',
    'ArmorBarbarianCapeJDT0TH',
    'ArmorBarbarianCapeJDT1TH',
    'HelmetLeatherT1_Terraheim_AddNewSets_AddLeatherArmor',
    'ArmorLeatherChestT1_Terraheim_AddNewSets_AddLeatherArmor',
    'ArmorLeatherLegsT1_Terraheim_AddNewSets_AddLeatherArmor',
    'HelmetTrollLeatherT2_Terraheim_AddNewSets_AddTrollLeatherArmor',
    'ArmorTrollLeatherChestT2_Terraheim_AddNewSets_AddTrollLeatherArmor',
    'ArmorTrollLeatherLegsT2_Terraheim_AddNewSets_AddTrollLeatherArmor',
    'HelmetBronzeT3_Terraheim_AddNewSets_AddBronzeArmor',
    'ArmorBronzeChestT3_Terraheim_AddNewSets_AddBronzeArmor',
    'ArmorBronzeLegsT3_Terraheim_AddNewSets_AddBronzeArmor',
    'HelmetIronT4_Terraheim_AddNewSets_AddIronArmor',
    'ArmorIronChestT4_Terraheim_AddNewSets_AddIronArmor',
    'ArmorIronLegsT4_Terraheim_AddNewSets_AddIronArmor',
    'HelmetDrakeT5_Terraheim_AddNewSets_AddSilverArmor',
    'ArmorWolfChestT5_Terraheim_AddNewSets_AddSilverArmor',
    'ArmorWolfLegsT5_Terraheim_AddNewSets_AddSilverArmor',
    'ArmorBarbarianBronzeLegsJDT3',
    'ArmorBarbarianBronzeChestJDT3',
    'ArmorBarbarianBronzeHelmetJDT3',
    'ArmorBarbarianBronzeLegsJDT3_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeChestJDT3_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeHelmetJDT3_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeLegsJDT4_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeChestJDT4_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeHelmetJDT4_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeLegsJDT5_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeChestJDT5_Terraheim_BarbarianArmor_AddNewSets',
    'ArmorBarbarianBronzeHelmetJDT5_Terraheim_BarbarianArmor_AddNewSets',
  ],
  Forsaken: [
    'v801_BattleaxeLightning',
    'v801_SpearSpirit',
    'v801_SledgePoison',
    'v801_SledgeFire',
    'v801_UnarmedFenring',
    'v801_UnarmedFrost',
    'v801_UnarmedFrostOH',
    'v801_ShieldFire',
    'v801_SwordFire',
    'v801_SwordLightning',
    'v801_SpellFire',
    'v801_BowFrost',
    'v801_KnifeFrost',
    'ArrowBone', 'ArrowLightning',
  ],
  RunicPack: [
    'RunicSwordRed', 'RunicSwordBlue', 'RunicSwordPurple', 'RunicSwordGreen',
    'RunicBowdRed', 'RunicBowBlue', 'RunicBowPurple', 'RunicBowGreen',
    'RunicAxeBlue', 'RunicAxeRed', 'RunicAxeGreen', 'RunicAxePurple',
    'JewellGreen', 'JewellRed', 'JewellPurple', 'JewellBlue',
    'JewellGreenS', 'JewellRedS', 'JewellPurpleS', 'JewellBlueS',
    'ArrowRunic',
    'CapeRunic',
  ],
  GoodestBoy: [
    'BestestDog', 'Bestest_Pup', 'BestestStick',
    'YummyBone', 'EvilBunny', 'BrownEvilBunny',
  ],
  OdinHorse: [
    'rae_OdinHorse', 'rae_Offspring_Normal', 'rae_SaddleHorse',
  ],
  Bears: [
    'Bear', 'Bear_ragdoll', 'Bear_cub', 'Bearcub_ragdoll', 'BearHide', 'rug_bear', 'TrophyBear',
  ],
  OdinBanners: [
    'rae_ob_banner_1', 'rae_ob_banner_1_big',
    'rae_ob_banner_2', 'rae_ob_banner_2_big',
    'rae_ob_banner_3', 'rae_ob_banner_3_big',
    'rae_ob_banner_4', 'rae_ob_banner_4_big',
    'rae_ob_banner_5', 'rae_ob_banner_5_big',
    'rae_ob_banner_6', 'rae_ob_banner_6_big',
    'rae_ob_banner_7', 'rae_ob_banner_7_big',
    'rae_ob_banner_8', 'rae_ob_banner_8_big',
    'rae_ob_banner_9', 'rae_ob_banner_9_big',
    'rae_ob_banner_10', 'rae_ob_banner_10_big',
    'rae_ob_banner_11', 'rae_ob_banner_11_big',
    'rae_ob_banner_12', 'rae_ob_banner_12_big',
    'rae_ob_banner_13', 'rae_ob_banner_13_big',
    'rae_ob_banner_14', 'rae_ob_banner_14_big',
    'rae_ob_banner_15', 'rae_ob_banner_15_big',
    'rae_ob_banner_16', 'rae_ob_banner_16_big',
  ],
  GuildPack: [
    'BannerBlack', 'BannerBlue', 'BannerGreen', 'BannerGrey', 'BannerPink', 'BannerPurple', 'BannerRed', 'BannerYellow',
    'FlagBlack', 'FlagBlue', 'FlagGreen', 'FlagGrey', 'FlagPink', 'FlagPurple', 'FlagRed', 'FlagYellow',
    'ClanShieldBlack', 'ClanShieldBlue', 'ClanShieldGreen', 'ClanShieldGrey', 'ClanShieldPink', 'ClanShieldPurple', 'ClanShieldRed', 'ClanShieldYellow',
    'CapeBlack', 'CapeBlue', 'CapeGreen', 'CapeGrey', 'CapePink', 'CapePurple', 'CapeRed', 'CapeYellow',
    'CapeBlackIce', 'CapeBlueIce', 'CapeGreenIce', 'CapeGreyIce', 'CapePinkIce', 'CapePurpleIce', 'CapeRedIce', 'CapeYellowIce',
    'CapeADM',
  ],
  // [thunderstore:OdinPlus/StarHeim]
  StarHeim: [
    'HansBlaster', 'KitFistoSaber', 'BlasterRifle', 'StormTrooperHelm', 'BlasterShot'
  ],
  BagualPack: [
    'BarrilGR', 'BarrilPQ', 'BarrilGRS',
    'Braseiro',
    'Cande_1Bra', 'Cande_3Bra', 'Cande_3Par',
    'Cande_1BraGold', 'Cande_5BraGold',
    'Caldeirao',
    'CrossCruzader',
    'Cup1Gold', 'Cup2Gold',
    'DishGold',
    'Eagle',
    'Estatua01',
    'FlametalDragon',
    'GargulaPantera',
    'LeaoPedra1', 'LeaoPedra2', 'LeaoPedra3',
    'Lustre_4Bra', 'Lustre_10Bra',
  ],
  EpicValheimsAdditions: [
    // bosses
    'Golden_Greydwarf_Miniboss', 'Golden_Troll_Miniboss', 'Golden_Wraith_Miniboss',
    'SvartalfrQueenAltar_New', 'Vegvisir_SvartalfrQueen', 'SvartalfarQueen',
    'JotunnAltar', 'Vegvisir_Jotunn', 'Jotunn',
    'BlazingDamnedOneAltar', 'Vegvisir_BlazingDamnedOne', 'HelDemon',
    // resource nodes
    'HeavymetalVein', 'FrometalVein_frac', 'BurningTree',
    // resources
    'PrimordialIce', 'BurningWorldTreeFragment', 'YmirsSoulEssence',
    'Heavyscale', 'Drakescale', 'Forgedscale',
    'OreHeavymetal', 'HeavymetalBar',
    'OreFrometal', 'FrometalBar',
    'DeepAbyssEssence',
    'ErrorDrop', 'EVA_AdminFood',
    // buildings
    'piece_alchemystation', 'piece_thorsforge',
    // items
    'BowFrometal', 'BowFlametal', 'BowHeavymetal',
    'AtgeirFrometal', 'AtgeirFlametal', 'AtgeirHeavymetal',
    'SledgeFrometal', 'SledgeFlametal', 'SledgeHeavymetal',
    'BattleaxeFrometal', 'BattleaxeFlametal', 'BattleaxeHeavymetal',
    'SpearFrometal', 'SpearFlametal', 'SpearHeavymetal',
    'KnifeFrometal', 'KnifeFlametal', 'KnifeHeavymetal',
    'MaceFrometal', 'MaceFlametal', 'MaceHeavymetal',
    'GreatswordFrometal', 'GreatswordFlametal', 'GreatswordHeavymetal',
    'ShieldFrometal', 'ShieldFlametal', 'ShieldHeavymetal',
    'ShieldTowerFrometal', 'ShieldTowerFlametal', 'ShieldTowerHeavymetal',
    'AxeFrometal', 'AxeFlametal', 'AxeHeavymetal',
    'PickaxeFrometal', 'PickaxeFlametal', 'PickaxeHeavymetal',
    'TridentDeepAbyss', 'BowDeepAbyss', 'GreatSwordDeepAbyss',
  ],
  MoreGates: [
    'h_drawbridge01', 'h_drawbridge02',
    'lift_gate', 'lift_gate2',
    'Hayze_gate_01', 'Hayze_gate_02', 'Hayze_gate_03', 'Hayze_gate_04', 'Hayze_gate_05', 'Hayze_gate_06',
    'h_door_01', 'h_door_02', 'h_door_03',
    'h_trapdoor', 'h_trapdoorbig', 'h_trapdoor2', 'h_trapdoorbig2',
    'Hayze_halfgate_01', 'Hayze_halfgate_02', 'hayzestake_01',
    'h_loglong26', 'h_loglong45', 'h_logshort26', 'h_logshort45',
    'h_window_01', 'h_window_02', 'h_window_03', 'h_window_04', 'h_window_05', 'h_window_06', 'h_window_07', 'h_window_08', 'h_window_09', 'h_window_10',
    'h_window_11', 'h_window_12', 'h_window_13', 'h_window_14',
    'h_chain', 'corewood_stack',
  ],
};
